<template>
  <div class="login-panel">
    <BaseTitle tag="h2">Members only extranet</BaseTitle>
    <div class="login-panel__body">
      <form @submit.prevent.stop="submitLogin" ref="formLogin" novalidate>

        <!-- Email address -->

        <ElementFormGroup :label-icon="'user'" :label="'Email Address'">
          <input
            :name="'email'"
            :id="'email'"
            :type="'email'"
            v-validate="`required|email`"
            v-model="email">
          <span :class="'error'" v-if="errors.has('email')">Please enter a valid email address</span>
        </ElementFormGroup>

        <!-- Password address -->

        <ElementFormGroup :label-icon="'padlock'" :label="'Password'">
          <template slot="link">
            <a href="#" @click.prevent.stop="showLoginPassword">Forget password ?</a>
          </template>
          <input
            :id="'password'"
            :name="'password'"
            :type="'password'"
            v-model="password">
          <span class="error" v-if="errors.has('password')">Please enter your password</span>
        </ElementFormGroup>

        <BaseCheckbox
                :guid="'keep-logged'"
                :value="'keepLogged'"
                :label="'Keep me logged in'"
                :active="keepLoggedIn"
                @change="handleKeepLoggedIn" />

        <button type="submit">Login</button>
      </form>
    </div>

    <div class="login-panel__info" v-if="errorMessage">
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import { setLocalStorage, removeLocalStorage } from '@modules/browser'
import BaseTitle from '@base/BaseTitle'
import BaseCheckbox from '@base/BaseCheckbox'
import ElementFormGroup from '@elements/ElementFormGroup'

export default {
  name: 'TheLoginPanel',
  components: {
    BaseTitle,
    BaseCheckbox,
    ElementFormGroup
  },
  data () {
    return {
      email: '',
      password: '',
      keepLoggedIn: false,
      error: false
    }
  },
  computed: {
    ...mapGetters({
      errorMessage: 'auth/getErrorMessage'
    })
  },
  methods: {
    ...mapActions({
      requestLogin: 'auth/requestLogin',
      updateErrorMessage: 'auth/updateErrorMessage',
      updateForgetPassword: 'auth/updateForgetPassword'
    }),
    showLoginPassword () {
      this.updateForgetPassword(true)
    },
    handleKeepLoggedIn ({ active }) {
      this.keepLoggedIn = active
    },
    submitLogin () {
      if (!this.isSubmitting) {
        this.$validator.validateAll().then(result => {
          this.error = !result
          if (result) {
            this.updateErrorMessage('')
            this.requestLogin({
              email: this.email,
              password: this.password,
              remember: this.keepLoggedIn
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.login-panel {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  // Title

  .title{
    order: 1;
    width: 100%;
    flex: 0 1 auto;
  }

  // Body

  &__body{
    order: 2;
    width: 100%;
    flex: 0 1 auto;
  }

  // Info

  &__info {
    @include form-info-error;
    order: 0;
  }

  .checkbox {
    margin-bottom: 1.5rem;
  }
}
</style>
